import { render, staticRenderFns } from "./SaButton.vue?vue&type=template&id=866535a0&scoped=true&"
import script from "./SaButton.vue?vue&type=script&lang=js&"
export * from "./SaButton.vue?vue&type=script&lang=js&"
import style0 from "./SaButton.vue?vue&type=style&index=0&id=866535a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "866535a0",
  null
  
)

export default component.exports